module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/shop_sunshouse_01-ae4f225bc6bc6493bee3ec5338b2692e.png";